/**
Project: Voice Panel (c)
Title: Numbers Table Header Columns  
Description: Settings related to Numbers list page table header column 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import IntlUtil from "../../../../core/helpers/intl-util";

export const InventoryTableHeaderColumns = (intlNamespace) => [
  {
    columnId: "numberCountryName",
    columnLabel: IntlUtil.getText(intlNamespace, "content.numberCountry"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "phoneNumber",
    columnLabel: IntlUtil.getText(intlNamespace, "content.number"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "communicationPlatform",
    columnLabel: IntlUtil.getText(intlNamespace, "content.Platform"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "userName",
    columnLabel: IntlUtil.getText(intlNamespace, "content.userName"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "city",
    columnLabel: IntlUtil.getText(intlNamespace, "content.city"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "country",
    columnLabel: IntlUtil.getText(intlNamespace, "content.country"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "carrierName",
    columnLabel: IntlUtil.getText(intlNamespace, "content.carrier"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "numberTypeName",
    columnLabel: IntlUtil.getText(intlNamespace, "content.type"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "departmentName",
    columnLabel: IntlUtil.getText(intlNamespace, "content.department"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "deviceType",
    columnLabel: IntlUtil.getText(intlNamespace, "content.device"),
    isSortable: false,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "manageStatus",
    columnLabel: IntlUtil.getText(intlNamespace, "content.managed"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "classification",
    columnLabel: IntlUtil.getText(intlNamespace, "content.classification"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "assignStatus",
    columnLabel: IntlUtil.getText(intlNamespace, "content.status"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "reserveStatus",
    columnLabel: IntlUtil.getText(intlNamespace, "content.reserved"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "numberNotes",
    columnLabel: IntlUtil.getText(intlNamespace, "content.notes"),
    isSortable: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
  {
    columnId: "actions",
    columnLabel: IntlUtil.getText(intlNamespace, "content.actions"),
    isSortable: false,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-inv-table-header-cell vpa-usn-table-header-cell-sort",
    tooltipClassName: null,
  },
];

export const DeviceModalTableHeaderColumns = (intlNamespace) => [
  {
    key: 1,
    content: IntlUtil.getText(intlNamespace, "content.device_type"),
  },
  {
    key: 2,
    content: IntlUtil.getText(intlNamespace, "content.make_Brand"),
  },
  {
    key: 3,
    content: IntlUtil.getText(intlNamespace, "content.model"),
  },
  {
    key: 4,
    content: IntlUtil.getText(intlNamespace, "content.serial_Number"),
  },
];

export const DeviceTableHeaderColumns = (intlNamespace) => [
  {
    key: 1,
    content: IntlUtil.getText(intlNamespace, "content.device_type"),
  },
  {
    key: 2,
    content: IntlUtil.getText(intlNamespace, "content.make_Brand"),
  },
  {
    key: 3,
    content: IntlUtil.getText(intlNamespace, "content.model"),
  },
  {
    key: 4,
    content: IntlUtil.getText(intlNamespace, "content.serial_Number"),
  },
  {
    key: 5,
    content: IntlUtil.getText(intlNamespace, "content.actions"),
  },
];
